import { selectSearchV2Enabled } from 'app/shared/featureFlags/selectors';
import { U21RuleSelect } from 'app/shared/u21-ui/components/dashboard';
import { U21RuleSearch } from 'app/shared/u21-ui/components/dashboard/U21RuleSearch';
import { useSelector } from 'react-redux';

interface OwnProps {
  onChange: (value: number[]) => void;
  value: number[];
}

export const RulesFilters = ({ onChange, value }: OwnProps) => {
  const isSearchV2Enabled = useSelector(selectSearchV2Enabled);

  return isSearchV2Enabled ? (
    <U21RuleSearch
      onChange={onChange}
      value={value}
      autoFocus
      backdrop
      clearable={false}
      label={undefined}
      multi
    />
  ) : (
    <U21RuleSelect
      onChange={onChange}
      value={value}
      autoFocus
      backdrop
      clearable={false}
      label={undefined}
      multi
    />
  );
};
